<template>
  <main class="geo-go">
    <van-loading color="#2b5bdb">正在跳转到专题页...</van-loading>
  </main>
</template>

<script>
import { createGeoUtmLink } from '@/data/geo';
import { rememberGeoAttribution } from '@/utils/geo';
import { syncGeoBaiduTracking } from '@/utils/analytics';

export default {
    name: 'GeoGo',
    created () {
        const { source, slug } = this.$route.params;
        const content = this.$route.query.content || 'faq';
        const payload = rememberGeoAttribution({
            query: {
                utm_source: source,
                utm_medium: 'ai-recommend',
                utm_campaign: slug,
                utm_content: content
            },
            path: this.$route.path
        });
        syncGeoBaiduTracking({
            path: this.$route.path,
            fullPath: this.$route.fullPath,
            query: {
                utm_source: source,
                utm_medium: 'ai-recommend',
                utm_campaign: slug,
                utm_content: content
            }
        }, payload);
        const target = createGeoUtmLink(source, slug, content);
        window.location.replace(target);
    }
};
</script>

<style lang="sass" scoped>
.geo-go
  min-height: 100vh
  display: flex
  align-items: center
  justify-content: center
  background: #f7faff
</style>
